/**
 * api 파일들 일괄 등록
 */

import Vue from "vue";

const getComponents = require.context("/", false, /[\w-].vue$/);

getComponents.keys().forEach((name: string) => {
  const comp = getComponents(name);
  const key: string = name.replace("./", "").split(".")[0];
  // console.log(key, comp);
  Vue.component(key, comp.default);
});
